import { render, staticRenderFns } from "./MainTerms.vue?vue&type=template&id=96d0ffaa&scoped=true&"
import script from "./MainTerms.vue?vue&type=script&lang=js&"
export * from "./MainTerms.vue?vue&type=script&lang=js&"
import style0 from "./MainTerms.vue?vue&type=style&index=0&id=96d0ffaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d0ffaa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
